import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <code>Mikhail Nikolaevskiy</code> &mdash; Frontend Developer
        </p>
        <a
          className="App-link"
          href="https://www.linkedin.com/in/mikhail-nikolaevskiy/?locale=en_US"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
      </header>
    </div>
  );
}

export default App;
